// extracted by mini-css-extract-plugin
export default {"products":"sA-z","card":"tA-z","oosMessaging":"uA-z"};